
import { map } from 'rxjs/operators';
import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { RestService } from '../providers/rest.service';
import { AuthenticationService } from '../auth/authentication.service';
import { PropertyDetailForOffer } from '../../shared/models/PropertyDetailForOffer';
import { OfferInputModel } from '../../shared/models/OfferInputModel';
import { ResultOutputModel } from '../models/resultOutputModel';
import { IOfferDetailOutputModel, IOfferDocsOutputModel } from '../models/OfferDetailOutputModel';
import { ILeadOffersOutputModel } from '../models/LeadOffersOutputModel';
import { CounterOfferModel } from '../models/CounterOfferModel';
import { ILeadCheckListEditModel } from '../../shared/models/LeadCheckListEditModel';
import { OffersSearchCriteriaModel } from '../../shared/models/OffersSearchCriteriaModel';
import { RequestModel } from '../../shared/models/RequestModel';
import { OfferDetailExpenseModel } from '../../shared/models/OfferDetailExpenseModel'
import { HttpClient } from '@angular/common/http';
import { IBuyerQuestionsModel } from '../models/BuyerQuestionsModel';
import { PrincipalEmailInputModel } from '../models/PrincipalEmailInputModel';

@Injectable()
export class OfferService extends RestService {

  constructor(private Authentication: AuthenticationService, protected http: HttpClient) {
    super(http);
  }

  // Get the property details by Guid
  getPropertyDetails(id: string) {
    return this.postForEntityObject<PropertyDetailForOffer>('property/propertyDetailsForOffer/' + id, '');
  }

  savePlaceOffer(offerInputModel: OfferInputModel): Observable<ResultOutputModel> {
    return this.postForEntityObject('property/placeOffer/', offerInputModel);
  }

  sendEmailToPrincipal(principalEmailInputModel: PrincipalEmailInputModel): Observable<ResultOutputModel> {
    return this.postForEntityObject('property/sendEmailToPrincipal/', principalEmailInputModel);
  }

  PlaceOfferMatchingUser(offerInputModel: OfferInputModel): Observable<any> {
    return this.postForEntityObject('property/PlaceOfferMatchingUser/', offerInputModel);
  }

  SaveBuyerQuestionnaire(buyerQuestionnaire: IBuyerQuestionsModel): Observable<boolean> {
  return this.postForEntityObject('property/SaveBuyerQuestionnaire/', buyerQuestionnaire);
  }

  SendBuyerQuestionsRemainder(offerId: number, loggedInUserId: number) {
    return this.post('property/SendBuyerQuestionsRemainder/' + offerId + '/' + loggedInUserId, '');
  }
  GetBuyerQuestionnaireDetails(input: any) {
    return this.post<IBuyerQuestionsModel>("property/GetBuyerQuestionnaireDetails/", input).pipe(map(response => {
      return response;
    }));
  }

  downloadLOITemplateToPDF(offerInputModel: OfferInputModel): Observable<string> {
    return this.postForEntityObject('property/downloadLOITemplateToPDF/', offerInputModel);
  }

  shareLOIToOtherMails(offerInputModel: OfferInputModel): Observable<boolean> {
    return this.postForEntityObject('property/shareLOIToOtherMails/', offerInputModel);
  }

  getOfferDetailForEdit(offerGuid: string): Observable<OfferInputModel> {
    return this.get<OfferInputModel>('opportunity/getOfferDetailForEdit/' + offerGuid);
  }



  savePlaceOfferToUserFlowLog(offerInputModel: OfferInputModel) {
    return this.postForEntityObject('property/savePlaceOfferToUserFlowLog/', offerInputModel);
  }

  getOfferDetails(offerId: string): Observable<IOfferDetailOutputModel> {
    let user: any = this.Authentication.user;
    return this.get<IOfferDetailOutputModel>('user1031/OfferDetail/' + offerId + '/' + user.Id);
  }

  GetPropertyContacts(propertyGuid: string, userid: number) {
    return this.get<boolean>('property/propertyContacts/' + propertyGuid + '/' + userid);
  }

  IsSellerOffer(sellerId, offerGuid) {
    return this.get<boolean>('opportunity/IsSellerOffer/' + sellerId + "/" + offerGuid);
  }

  getLeadOffers(offerId: string) {
    return this.GET('user1031/LeadOffers/' + offerId);
  }

  getPendingPortfolioProperties(loggedinuserid: number, userGuid: string) {
    return this.GET('opportunity/PendingPortfolioProperties/' + loggedinuserid + '/' + userGuid);
  }

  getCounterOfferDetails(offerGuid: string): Observable<CounterOfferModel> {
    return this.get<CounterOfferModel>('opportunity/CounterOfferDetail/' + offerGuid);
  }

  getOfferDocsList(offerGuid: string) {
    return this.GET('opportunity/offerDocs/' + offerGuid);
  }

  saveCounterOffer(counterOfferModel: CounterOfferModel): Observable<ResultOutputModel> {
    return this.postForEntityObject('opportunity/saveCounterOffer/', counterOfferModel);
  }

  saveOfferExpense(offerDetailExpenseModel: OfferDetailExpenseModel) {
    return this.postForEntityObject('opportunity/saveOfferExpense/', offerDetailExpenseModel);
  }

  getOfferExpenseList(offerGuid: string) {
    return this.GET('opportunity/offerExpenseList/' + offerGuid);
  }

  GetOfferProgressChartData(offerGuid: string) {
    return this.GET('user1031/OfferProgressChartData/' + offerGuid);
  }
  GetOfferProgressBriefChartData(offerGuid: string) {
    return this.GET('user1031/OfferProgressBriefChartData/' + offerGuid);
  }
  GetOfferProgressByExchangeId(exchangeId: number) {
    return this.GET('user1031/GetOfferProgressByExchangeId/' + exchangeId);
  }
  GetTaskSummaryFordashboard(exchangeId: number) {
    return this.GET('user1031/GetTaskSummaryFordashboard/' + exchangeId);
  }
  GetOfferTaskList(offerGuid: string, userId: number) {
    return this.GET('user1031/OfferTaskList/' + offerGuid + '/' + userId);
  }
  AddCalenderEvent(id: number, leadPhaseId:number, userId:number, subscribe: number, offset: number) {
    return this.GET('opportunity/addCalenderEvent/' + id + "/" + leadPhaseId + "/" + userId + "/" + subscribe + "/" + offset);
  }
  GenerateDealReport(offerGuid: string, userId: number, OffsetTime: number) {
    return this.GET('opportunity/generateDealReport/' + offerGuid + "/" + OffsetTime + "/" + userId);
  }
  CalenderEventSubscription(leadDetailId: number, userId: number, subscribe: number, offset: number) {
    return this.GET('opportunity/calenderEventSubscription/' + leadDetailId + "/" + userId + "/" + subscribe + "/" + offset);
  }
  ChangeLeadChecklistTaskStatus(LeadCheckListId, Status, Userid) {
    return this.postForEntityObject('user1031/ChangeLeadChecklistTaskStatus/' + LeadCheckListId + "/" + Status + "/" + Userid, '');
  }

  ChangeLeadPhaseStatus(LeadPhaseId, Status, Userid) {
    return this.postForEntityObject('user1031/ChangeLeadPhaseStatus/' + LeadPhaseId + "/" + Status + "/" + Userid, '');
  }

  DeleteLeadChecklistTask(LeadCheckListId, userId) {
    return this.postForEntityObject('user1031/DeleteLeadChecklistTask/' + LeadCheckListId + "/" + userId, '');
  }

  GetLeadChecklistTaskDetailsToEdit(LeadCheckListId): Observable<ILeadCheckListEditModel> {
    return this.get<ILeadCheckListEditModel>('user1031/LeadChecklistTaskDetailsToEdit/' + LeadCheckListId);
  }

  UpdateLeadCheckList(input: any) {
    return this.postForEntityObject<boolean>("user1031/UpdateLeadCheckList", input);
  }

  CreateOfferSpecificTask(input: any) {
    return this.postForEntityObject<boolean>("user1031/CreateOfferSpecificTask", input);
  }


  GetLeadSummary(input) {
    return this.post('opportunity/leadsummary/', input);
  }

  UpdateLeadRating(id: number, rating: number) {
    return this.GET('opportunity/updateleadrating/' + id + "/" + rating);
  }

  DeleteSelectedOffers(input: any) {
    let url = "opportunity/DeleteSelectedOffers/" + input;
    return this.post(url, input).pipe(map(response => {
      return response;
    }));
  }

  ChangeSelectedOffersStatus(leadId, status) {
    return this.post('opportunity/ChangeSelectedOffersStatus/' + status, leadId);
  }

  // check Duplicate CoBroker place offer Entry 
  checkDuplicatePlaceOfferByCoBroker(offerInputModel: OfferInputModel) {
    return this.postForEntityObject('opportunity/checkDuplicatePlaceOfferByCoBroker/', offerInputModel);
  }

  // check Duplicate Principal data 
  checkDuplicatePrincipal(offerInputModel: OfferInputModel) {
    return this.postForEntityObject('opportunity/checkDuplicatePrincipal/', offerInputModel);
  }

  changeOfferStatusUsingGuid(requestModel: RequestModel) {
    return this.postForEntityObject('opportunity/changeOfferStatusUsingGuid/', requestModel);
  }

  acceptOrRejectOffer(requestModel: RequestModel): Observable<ResultOutputModel> {
    return this.postForEntityObject('opportunity/acceptOrRejectOffer/', requestModel);
  }

  downloadLOI(objectId: number, fileType: string, Id: number) {
    return this.GET('/upload/file/' + objectId + '/' + fileType + '/' + Id);
  }

  GetDefaultTask(offerGuid) {
    return this.GET('opportunity/GetDefaultTask/' + offerGuid);
  }

  GetTaskAssignee(offerGuid) {
    return this.GET('opportunity/GetTaskAssignee/' + offerGuid);
  }

  SaveAssignedTask(offerGuid, userId, taskAssignModel) {
    return this.postForEntityObject('opportunity/SaveAssignedTask/' + offerGuid + "/" + userId, taskAssignModel);
  }

  SaveTaskPhaseDetails(offerGuid, taskPhaseList) {
    return this.postForEntityObject('opportunity/SaveTaskPhaseDetails/' + offerGuid + "/", taskPhaseList);
  }


  GetAssociatedStatus(statusType) {
    return this.GET('opportunity/GetAssociatedStatus/' + statusType);
  }

  GetTaskPhaseDetails(offerGuid: string, userId : number) {
    return this.GET('opportunity/GetTaskPhaseDetails/' + offerGuid + "/" + userId);
  }

  UpdateTaskPhaseDetails(taskPhaseDetailsIModel) {
    return this.postForEntityObject('opportunity/UpdateTaskPhaseDetails/', taskPhaseDetailsIModel);
  }

  DeleteTaskPhaseDetails(id, userId) {
    return this.postForEntityObject('opportunity/DeleteTaskPhaseDetails/' + id + "/" + userId, null);
  }

  CheckNewOfferExistOnCancelledOffer(userId, propertyGuid) {
    return this.GET('opportunity/CheckNewOfferExistOnCancelledOffer/' + userId + "/" + propertyGuid);
  }

  checkDuplicateUser(offerInputModel: OfferInputModel): Observable<OfferInputModel>  {
    return this.postForEntityObject('opportunity/UserDetails/', offerInputModel);
  }

  GetOfferDocuments(offerId: string) {
    return this.GET('property/OfferDocuments/' + offerId);
  }
}
